var overArg = require('./_overArg');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;



//////////////////
// WEBPACK FOOTER
// ./~/ngcomponent/~/lodash/_nativeKeys.js
// module id = ./node_modules/ngcomponent/node_modules/lodash/_nativeKeys.js
// module chunks = 1